module.exports = __webpack_public_path__ + "static/media/pay_success.b9f27f5a.svg";